import React from "react";
import { Link, useLocation } from "react-router-dom";
import usePrivateLink from "../config/usePrivateLink";

export default function Master() {
    const { pathname } = useLocation();

    const hasAccess = usePrivateLink();
    return (
        <>
            <div className="col-12">
                <div className="d-flex gap-2 align-items-center mb-3">
                    {hasAccess("/fees/report/dashboard") && (
                        <Link
                            to={"/fees/report/dashboard"}
                            className={`btn ${pathname === "/fees/report/dashboard"
                                ? "btn-primary"
                                : "btn-outline-primary btn-sm"
                                }`}
                        >
                            <i className="ri-money-rupee-circle-line me-2 ri-20px"></i>Fees Dashboard                        </Link>
                    )}
                    {hasAccess("/fees/collection") && (
                        <Link
                            to={"/fees/collection"}
                            className={`btn ${pathname === "/fees/collection"
                                ? "btn-primary"
                                : "btn-outline-primary btn-sm"
                                }`}
                        >
                            <i className="ri-money-rupee-circle-line me-2 ri-20px"></i>Fees Collection                        </Link>
                    )}

                    {hasAccess("/fees/followup/v2") && (
                        <Link
                            to={"/fees/followup/v2"}
                            className={`btn ${[
                                "/fees/followup/v2",
                            ].includes(pathname) ? "btn-primary"
                                : "btn-outline-primary btn-sm"
                                }`}
                        >
                            <i className="ri-group-line me-2 ri-20px"></i>
                            Fees Followups
                        </Link>
                    )}

                    {hasAccess("/student/due/fees") && (
                        <Link
                            to={"/student/due/fees"}
                            className={`btn ${pathname === "/student/due/fees"
                                ? "btn-primary"
                                : "btn-outline-primary btn-sm"
                                }`}
                        >
                            <i className="ri-money-rupee-circle-line me-2 ri-20px"></i>
                            Due Fees
                        </Link>
                    )}
                    {hasAccess("/student/due/registration") && (
                        <Link
                            to={"/student/due/registration"}
                            className={`btn ${pathname === "/student/due/registration"
                                ? "btn-primary"
                                : "btn-outline-primary btn-sm"
                                }`}
                        >
                            <i className="ri-money-rupee-circle-line me-2 ri-20px"></i>
                            Due Registration
                        </Link>
                    )}


                </div>
            </div>

        </>
    );
}
